/* Apply only to storefront merchandise imagery, including dynamically loaded results. */
(() => {
  const fallback = document.body.dataset.wwImageFallback;
  if (!fallback) return;
  const selector = '.product-item__image-wrapper img, .productCard__imageWrap img, .ww-featured-drop__product-media img, .collectionList__img, .product-gallery img, .mini-cart__image-wrapper img, .line-item__image-wrapper img, .sd_searchimage img, .collection-list-2__product--img';
  const isGeneric = (url) => (/(?:NoPicAvailable|no-image|dfw_placeholder)(?:[_\-.?]|$)/i.test(url || '') || /images\.binderpos\.com\/[^/?]*_placeholder\./i.test(url || ''));
  function replace(img) {
    if (!img.matches(selector) || img.dataset.wwFallbackApplied || img.classList.contains('ww-image-placeholder__logo')) return;
    img.dataset.wwFallbackApplied = 'true';
    img.classList.remove('lazy', 'lazyload', 'lazyloading', 'image--fade-in');
    img.classList.add('ww-image-fallback');
    ['srcset', 'sizes', 'data-src', 'data-srcset', 'data-sizes', 'data-widths', 'data-zoom'].forEach((name) => img.removeAttribute(name));
    img.alt = 'Wayward City Games — image unavailable';
    img.src = fallback;
  }
  function check(img) {
    const source = img.getAttribute('data-src') || img.getAttribute('src') || '';
    if (isGeneric(source) || (img.getAttribute('src') && img.complete && img.naturalWidth === 0)) replace(img);
  }
  function scan(root) {
    if (root.matches && root.matches(selector)) check(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(check);
  }
  document.addEventListener('error', (event) => {
    if (event.target instanceof HTMLImageElement) replace(event.target);
  }, true);
  scan(document);
  new MutationObserver((records) => records.forEach((record) => {
    if (record.type === 'attributes') scan(record.target);
    else record.addedNodes.forEach(scan);
  })).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'data-src', 'srcset']});
})();
